import * as React from "react";

import { ConnectProto } from "@racoon/api";
import { Namespace, TranslationKey, useT } from "@racoon/i18n";
import { getEnumName } from "@racoon/lib";

import { WhatsAppReportModal } from "~/features/whatsapp-report-modal/ui/whatsapp-report.modal";
import { containerLabel } from "../model/container-volume";
import { getStatusBadge } from "../model/review-status";

export const MswReportHeader: React.FC<{ job: ConnectProto.Job }> = ({ job }) => {
  const t = useT();
  const statusBadge = getStatusBadge(job.dispatcherReviewStatus);
  const jobTypeName = getEnumName(ConnectProto.JobTypeSchema, job.type);
  const container = containerLabel(job);

  return (
    <div className="flex w-full min-w-0 items-center gap-4">
      <div className="flex flex-col gap-1 whitespace-nowrap">
        <span className="text-lg font-bold leading-[18px] tracking-[-0.09px] text-text-body">
          {job.pickupLocation?.name}
        </span>
        <span className="text-xs font-bold uppercase leading-4 text-[#667489]">
          {t(Namespace.PhotoReport, "jobReportTitle")}
        </span>
      </div>
      <div
        className={`shrink-0 rounded-md border border-transparent px-2 py-0.5 text-xs font-medium leading-4 ${statusBadge.bgColor} ${statusBadge.color}`}
      >
        {t(Namespace.Enum, statusBadge.labelKey as TranslationKey)}
      </div>
      <div className="flex min-w-0 items-center gap-6 whitespace-nowrap text-sm leading-4 text-text-body">
        {job.serviceReceiver?.name && <span>{job.serviceReceiver.name}</span>}
        {job.serviceProvider?.name && (
          <span className="min-w-0 max-w-[184px] truncate" title={job.serviceProvider.name}>
            {job.serviceProvider.name}
          </span>
        )}
        {job.orderNumber && <span className="font-medium">{job.orderNumber}</span>}
        <span className="flex gap-3">
          {jobTypeName && <span>{t(Namespace.Enum, jobTypeName)}</span>}
          {container && <span>{container}</span>}
        </span>
      </div>
      {/* Keyed by job: the arrows swap the job under the header. */}
      <div className="ml-auto shrink-0">
        <WhatsAppReportModal key={String(job.id)} job={job} />
      </div>
    </div>
  );
};
